import { Injectable } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { UserInputService } from '../api/services/user-input.service'

@Injectable({
  providedIn: 'root'
})
export class FormFieldHelperService {
  constructor (private userInputService: UserInputService) {}

  clearFields (form: FormGroup, fields: string[], prefix: string = ''): void {
    fields.forEach(field => {
      form.get(field)?.setValue('')
      const storageKey = prefix ? `${prefix}_${field}` : field
      this.userInputService.deleteValue(storageKey)
    })
  }

  clearValidatorsAndUpdate (form: FormGroup, fields: string[]): void {
    fields.forEach(field => {
      const control = form.get(field)
      control?.clearValidators()
      control?.updateValueAndValidity()
    })
  }

  clearFieldsWithValidators (form: FormGroup, fields: string[], prefix: string = ''): void {
    this.clearFields(form, fields, prefix)
    this.clearValidatorsAndUpdate(form, fields)
  }
}
